import { call, cancelled, put, select, takeLatest } from "redux-saga/effects";
import { fetchDiseaseRisk } from "../../../api/diseaseRiskApi";
import { logout } from "../../../store/features/auth/authSlice";
import { cancelDiseaseRisk, fetchDiseaseRiskFailure, fetchDiseaseRiskStart, fetchDiseaseRiskSuccess } from "../../../store/features/customer/diseaseRisk/diseaseRiskSlice";
import { getRiskError } from "../../../utils/diseaseRiskUtils";

export function* fetchDiseaseRiskSaga(action) {
  if (action.type !== fetchDiseaseRiskStart.type) return;
  const request = action.payload;
  const controller = new AbortController();
  try {
    const cached = yield select((state) => state.diseaseRisk?.cache?.[request.key]);
    const data = cached && !request.force ? cached : yield call(fetchDiseaseRisk, request, controller.signal);
    yield put(fetchDiseaseRiskSuccess({ requestId: request.requestId, data }));
  } catch (error) {
    yield put(fetchDiseaseRiskFailure({ requestId: request.requestId, error: getRiskError(error) }));
  } finally {
    if (yield cancelled()) controller.abort();
  }
}

export default function* diseaseRiskSaga() {
  yield takeLatest([fetchDiseaseRiskStart.type, cancelDiseaseRisk.type, logout.type], fetchDiseaseRiskSaga);
}
